import React from "react";
import "./Main.css";

import { About } from "../About/About";

export const MainSections: React.FC = () => {
  return (
    <main>
      <About />
    </main>
  );
};
